/* eslint-disable */

import { MODULE_NAME } from './const';
import { SET_LEFT_SIDE_DRAWER_STATE } from './mutations';
import StoreModuleService from '../StoreModuleService';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';
import { closeSideBar } from '@/store/modules/selectedNode/actions';
import { reset as resetGeneralConfigurationWidgetEditor } from '@/store/modules/configurationEditor/modules/generalConfigurationWidgetEditor/actions';
import { reset as resetUserConfigurationWidgetEditor } from '@/store/modules/configurationEditor/modules/userConfigurationWidgetEditor/actions';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const clearLeftSideBar = buildActionObject('clearLeftSideBar');
export const setLeftSideDrawerState = buildActionObject('setLeftSideDrawerState');

const actions = {
	...StoreModuleService.createDefaultActions(),
	[setLeftSideDrawerState.action]({ commit, dispatch }, payload) {
		if (payload) {
			dispatch(closeSideBar.fullPath, {}, { root: true });
		}
		commit(SET_LEFT_SIDE_DRAWER_STATE, payload);
	},
	async [clearLeftSideBar.action]({ dispatch }) {
		await Promise.all([
			dispatch(setLeftSideDrawerState.action, DRAWER_MODES.closed),
			dispatch(resetUserConfigurationWidgetEditor.fullPath, {}, { root: true }),
			dispatch(resetGeneralConfigurationWidgetEditor.fullPath, {}, { root: true }),
		]);
	},
};

export default actions;
